import { render, staticRenderFns } from "./RoleActivityList.vue?vue&type=template&id=5b15a5b1&scoped=true"
import script from "./RoleActivityList.vue?vue&type=script&lang=ts"
export * from "./RoleActivityList.vue?vue&type=script&lang=ts"
import style0 from "./RoleActivityList.vue?vue&type=style&index=0&id=5b15a5b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b15a5b1",
  null
  
)

export default component.exports